namespace GeniuzPOS.Purchase {
    export class ListAppInvoiceReceiveColumns {
        static columnsKey = 'Purchase.ListAppInvoiceReceive';
    }
}
